if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      createUniqueKey() {
        const characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const keyLength = 32;
        let key = "";

        for (let i = 0; i < keyLength; i++) {
          const randomIndex = Math.floor(Math.random() * characters.length);
          key += characters[randomIndex];
        }

        return key;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        // Add upsell item to form data
        const upsellProductItems = document.querySelectorAll(
          "upsell-product-item"
        );

        const selectedUpsellProducts = [];

        for (let upsellProductItem of upsellProductItems) {
          const selectedVariantId = upsellProductItem.getAttribute(
            "selected-variant-id"
          );
          const quantity = upsellProductItem.getAttribute("quantity");

          if (selectedVariantId) {
            const item = {
              id: selectedVariantId,
              quantity: quantity,
            };

            if (this.cart) {
              item.sections = this.cart
                .getSectionsToRender()
                .map((section) => section.id);
              item.sections_url = window.location.pathname;

              this.cart.setActiveElement(document.activeElement);
            }

            selectedUpsellProducts.push(item);
          }
        }

        if (selectedUpsellProducts.length > 0) {
          const key = this.createUniqueKey();
          config.headers["Content-Type"] = "application/json";

          const items = [
            {
              ...Object.fromEntries(formData.entries()),
              properties: { _key: key },
            },
            ...selectedUpsellProducts.map((product) => ({
              ...product,
              properties: { _parent: key },
            })),
          ];

          config.body = JSON.stringify({
            items: items,
          });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              if (window.AVADA_BOOSTSALE) {
                const SKIP_STORAGE_KEY = "__skip_offer";
                const product = window.AVADA_BOOSTSALE.product;
                const collectionIds = window.AVADA_BOOSTSALE.collections;
                const offers = window.AVADA_BOOSTSALE.offer;
                const skipOffer =
                  window.localStorage.getItem(SKIP_STORAGE_KEY) || [];

                const hasPopupOffer =
                  !skipOffer.includes(product.id) &&
                  offers &&
                  offers.some((o) => {
                    if (o.triggerCondition == "specific-product") {
                      return (
                        o.widgetStyle == "popup" &&
                        o.triggerProducts
                          .map((p) => p.id)
                          .includes(String(product.id))
                      );
                    } else {
                      return (
                        o.widgetStyle == "popup" &&
                        o.triggerCollections.some((c) =>
                          collectionIds.includes(String(c.id))
                        )
                      );
                    }
                  });

                if (hasPopupOffer) {
                  setTimeout(() => {
                    document
                      .querySelectorAll(
                        ".Avada-OfferPop__Close, .Avada-Offer__SkipOffer span"
                      )
                      .forEach((el) =>
                        el.addEventListener("click", (e) => {
                          skipOffer.push(product.id);
                          window.localStorage.setItem(
                            SKIP_STORAGE_KEY,
                            JSON.stringify(skipOffer)
                          );
                          window.location = window.routes.cart_url;
                        })
                      );

                    document
                      .querySelectorAll(".Avada-Offer__ButtonAddToCart ")
                      .forEach((el) =>
                        el.addEventListener("click", (e) => {
                          skipOffer.push(product.id);
                          window.localStorage.setItem(
                            SKIP_STORAGE_KEY,
                            JSON.stringify(skipOffer)
                          );
                        })
                      );
                  }, 500);

                  return;
                }
              }
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
